// extracted by mini-css-extract-plugin
export default {"container":"style_container__cxnu4","left":"style_left__JWQF+","right":"style_right__4pyMV"};